import { siteConfig } from "../config/site";
import type { Ticket } from "../types/ticket";
import { formatCurrency } from "./money";

export function buildWhatsAppUrl(message: string) {
  const url = new URL(siteConfig.whatsappUrl);
  url.searchParams.set("text", message);
  return url.toString();
}

export function buildGeneralWhatsAppUrl(context = "General booking enquiry") {
  return buildWhatsAppUrl([
    `Hello ${siteConfig.brandName},`,
    "",
    `I would like help with: ${context}`,
    `Event: ${siteConfig.eventName}`,
    `Race weekend: ${siteConfig.competitiveWeekend}`,
    `Venue: ${siteConfig.venue}`,
    "",
    "Please share the current availability, pricing and next booking steps.",
    "Before any payment, please provide a written itemised quote showing the ticket/package price, applicable taxes, booking/service fees and total payable amount.",
  ].join("\n"));
}

export function buildTicketWhatsAppUrl(ticket: Ticket) {
  const price = ticket.price === null ? "Please share the current special price" : `${formatCurrency(ticket.price)}${ticket.priceBasis ? ` · ${ticket.priceBasis}` : " per ticket"}`;

  return buildWhatsAppUrl([
    `Hello ${siteConfig.brandName},`,
    "",
    "I would like to enquire about this race-weekend package:",
    `Event dates: ${ticket.eventDate}`,
    `Published price: ${price}`,
    `${ticket.category === "paddock" ? "Details to confirm" : "Key inclusions"}: ${ticket.inclusions.join(", ")}`,
  ].join("\n"));
}
